import { Header, Page, Toolbox } from 'redesign';
import { CompaniesFilterToolbox } from './components/companies-filter-form/companies-filter-form';
import { COMPANIES_FILTER_INITIAL_VALUE } from './companies.types';
import { CompaniesList } from './companies-list';
import { useExternalParams } from '../../../../shared/hooks';

export const Companies = () => {
  const [params, setParams] = useExternalParams(COMPANIES_FILTER_INITIAL_VALUE);

  return (
    <Page
      header={<Header titleText="Bedrijven" />}
      toolbox={
        <Toolbox>
          <CompaniesFilterToolbox params={params} setParams={setParams} />
        </Toolbox>
      }
    >
      <CompaniesList params={params} />
    </Page>
  );
};
